import React, { Fragment, useEffect } from 'react';
import { Button, Col, Dropdown, Image, Menu, Row, Statistic, message } from '@nackle/paper';
import { LocaleString, getString } from '@nackle/intl-tools';
import { DownArrow, Launch, Logout } from 'app/components/shared/icons/icons';
import { getPointBalance, getMenuItems, getMarketplaceUrl, getLogosAndColors } from 'app/app-dux/recognition-dux';
import { useDispatch, useSelector } from 'react-redux';

const goToMarketplace = async ( shopUrl ) => {
	const screen = {
		availWidth: 300,
		availHeight: 500
	};
	if ( shopUrl ) {
		window.open( shopUrl, '_blank', `directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=no,resizable=no,width=${ screen.availWidth },height=${ screen.availHeight }` );
	} else {
		message.error( getString( 'recognition.error.uhOh' ) );
	}
};

export const menu = ( props ) => {
	const {
		menuItems,
		changeRoute
	} = props;

	const dispatch = useDispatch();

	const handleLogout = () => {
		changeRoute( 'appcode' );
		localStorage.clear();
	};

	const handleMarketplace = async ( event ) => {
		const shopUrl = await dispatch( getMarketplaceUrl( event.key ) );
		goToMarketplace( shopUrl );
	};

	return (
		<Menu className='shop-menu-container'>
			{
				menuItems?.map( menu => {
					return (
						<Menu.Item key={ menu?.pageType } onClick={ handleMarketplace }>
							<Row align="center" justify="space-between" gutter='0'>
								<Col>
									<div className="shop-menu-item">
										<Image src={ menu?.colorLogo } width={ 25 } height={ 25 } preview={ false }/>
										<span>{ menu.pageType }</span>
									</div>
								</Col>
								<Col> <Launch/> </Col>
							</Row>
						</Menu.Item>
					);
				} )
			}
			<Menu.Divider />
			<Menu.Item key="3" onClick={ () => handleLogout() }>
				<Row align="middle">
					<Col flex={ 1 }>
						<LocaleString code="recognition.header.logout" />
					</Col>
					<Col> <Logout/> </Col>
				</Row>
			</Menu.Item>
		</Menu>
	);
};

export function MainHeader( { changeRoute } ) {
	const dispatch = useDispatch();
	const balance = useSelector( state => state.recognition.balance );
	const menuItems = useSelector( state => state.recognition.menuItems );
	const branding = useSelector( state => state.recognition.branding );

	useEffect( () => {
		const fetchData = async () => {
			try {
				const res = await Promise.all( [
					dispatch( getLogosAndColors() ),
					dispatch( getPointBalance() ),
					dispatch( getMenuItems() )
				] );
				await Promise.all( res.map( r => r ) );
			} catch ( err ) {
				message.error( getString( 'recognition.error.uhOh' ) );
			}
		};

		fetchData();
	}, [] );

	const menuProps = {
		menuItems,
		changeRoute
	};

	return (
		<Fragment>
			<Row className="main-header spacer-lr-16 space-tb-16" justify="space-between" gutter='0'>
				<Row className="logoContainer">
					<Image
						src={ branding.primaryLogo }
						width={ 40 }
						height={ 40 }
						preview={ false }
					/>
				</Row>
				<Row className="pointsContainer" align="middle">
					<Col>
						<Statistic title={ getString( 'recognition.header.balanceLabel' ) } value={ balance } valueStyle={ { color: '#e75c3a' } }/>
					</Col>
					<Col>
						<div className="dropdown-arrow-button">
							<Dropdown overlay={ menu( menuProps ) } trigger={ [ 'click' ] }>
								<Button className="menu-button" icon={ <DownArrow width={ 10 } height={ 6 } fill="#00000029"/> }/>
							</Dropdown>
						</div>

					</Col>
				</Row>
			</Row>
		</Fragment>
	);
}